/**
 * 회비결제방식 창 ($j.Ui.JBModal.target 결합) — 기사편집 「회비결제방식」 ⚙.
 *
 * 받는 길은 다섯 갈래(충전금 · CMS · 장기선결제 · 장기감면 · 면제)인데 예전 ⚙ 은 장기선결제 추가 창만 열었다.
 * CMS 는 CMS 회원 리스트, 감면은 화면이 없어서 어디서 무엇을 바꾸는지 알 수 없었다. 여기 한 곳에서 다 보고 바꾼다.
 *
 *   맨 위   지금 실제로 받는 길 한 줄(서버 MemberFeeService::wayDetail — 월초 배치와 같은 판정) + 겹친 설정 경고
 *   갈래    판정 순서대로. 지금 받는 갈래에 표시, 갈래마다 설정값과 바꾸는 버튼
 *           CMS — 코드 등록 · 수정 · 해제(기존 CMS 회원 리스트와 같은 엔드포인트)
 *           장기선결제 — 추가(PrepayForm) · 내역/환불(PrepayLog). 그 창이 닫히면 여기를 다시 읽는다
 *           장기감면 · 면제 — 읽기전용. 장기감면은 매달 1일 배치가 감면 기록으로 잇고 풀고, 면제도 여기서 바꾸지 않는다
 *   맨 아래 업종 — 월회비가 왜 그 금액인지
 *
 * 바꾸면 본창 「회비결제방식」 값(#meFeeView)도 맞춘다.
 *
 *   $j.Ui.JBModal.target('fee-way-modal', { target: '$j.F.Admin.Member.FeeWay', data: { mbNo }, title: '회비결제방식', width: '560px' });
 */
import Util from '../../../Common/Util';
export default class FeeWay {
    destroy() {
        $(`#${this.id}`).off();
        $j.Common.EventBus.offNamespace('FeeWay');
    }

    init() {
        this.mbNo = this.data.mbNo;
        $(`#${this.id}`).html('<div class="fw-empty">불러오는 중…</div>');
        this.bind();
        // 선결제 추가 · 내역 창이 닫히면 다시 읽는다 — 그 창이 선결제를 바꿨을 수 있다
        $j.Common.EventBus.on('FeeWay', 'JBModal:close', (e, p) => { if (p && (p.id === 'prepay-modal' || p.id === 'prepay-log-modal')) this.load(); });
        this.load();
    }

    async load() {
        let d = null;
        try { d = await $.getJSON(`/adm/ajax/member/${this.mbNo}/fee-way`); } catch (e) { /* 아래 안내 */ }
        if (!d || !d.result) { $(`#${this.id}`).html(`<div class="fw-empty">${this._esc((d && d.message) || '불러오지 못했습니다.')}</div>`); return; }
        this.d = d;
        this.draw();
        $('#meFeeView').text(d.text);   // 본창 값도 맞춘다
    }

    draw() {
        const d = this.d, won = (n) => `${Util.formatNumber(n)}원`;
        const row = (way, body, act = '') => {
            const on = d.way === way;
            return `<div class="fw-row${on ? ' is-on' : ''}">
                <div class="fw-row__h"><b>${this._esc(d.labels[way])}</b>${on ? '<span class="fw-now">적용 중</span>' : ''}<span class="fw-sp"></span>${act}</div>
                <div class="fw-row__help">${this._esc(d.help[way])}</div>${body ? `<div class="fw-row__b">${body}</div>` : ''}</div>`;
        };
        const cms = d.cms
            ? `코드 <b>${this._esc(d.cms)}</b>
               <input type="text" class="me-input fw-cms-in" placeholder="새 코드" style="width:110px">
               <button type="button" class="me-btn fw-cms" data-act="edit">수정</button>
               <button type="button" class="me-btn fw-cms" data-act="release">해제</button>`
            : `<input type="text" class="me-input fw-cms-in" placeholder="더빌 CMS 코드" style="width:140px">
               <button type="button" class="me-btn fw-cms" data-act="register">등록</button>`;
        // 시작 전이면 「예정」 — 그달 1일 배치가 선결제로 바꾼다. 그 전까지 「현재」는 지금 방식 그대로다
        const pre = d.prepay ? `${d.prepay.upcoming ? '<span class="fw-plan">예정</span> ' : ''}<b>${this._esc(d.prepay.period)}</b> · ${won(d.prepay.price)}` : '없음';

        const html = `<div class="fw">
            <div class="fw-head">현재 <b>${this._esc(d.text)}</b></div>
            ${d.warn.map((w) => `<div class="fw-warn"><i class="fas fa-triangle-exclamation"></i> ${this._esc(w)}</div>`).join('')}
            ${!d.paid ? row('free', '') : ''}
            ${row('exempt', d.nofee === 2 ? '면제 중' : '', '<span class="fw-ro">읽기전용</span>')}
            ${row('nofee', d.nofee === 1 ? '장기감면 중 — 매달 1일, 지난달 수주가 있으면 배치가 감면을 풉니다' : '', '<span class="fw-ro">읽기전용</span>')}
            ${row('cms', cms)}
            ${row('prepay', pre, `<button type="button" class="me-btn fw-pre" data-act="add">추가</button><button type="button" class="me-btn fw-pre" data-act="log">내역 · 환불</button>`)}
            ${row('cash', '')}
            ${d.types.length ? `<div class="fw-types">업종 ${d.types.map((t) => `<span class="fw-type${t.fee ? ' is-fee' : ''}">${this._esc(t.car_type)} · ${this._esc(t.kind)}</span>`).join(' ')}
                <div class="fw-row__help">월회비 = ${won(d.perType)} × (1 + 타업종 ${d.extra}) — 업종 추가 · 해지는 「기사 / 장비 관리」 › 업체 홈 「업종 · 월회비」</div></div>` : ''}
        </div>`;
        $(`#${this.id}`).html(this._style() + html);
    }

    bind() {
        const $el = $(`#${this.id}`), self = this;
        $el.on('click', '.fw-cms', function () { self.cms(String($(this).data('act'))); });
        $el.on('click', '.fw-pre', function () {
            const add = $(this).data('act') === 'add';
            $j.Ui.JBModal.target(add ? 'prepay-modal' : 'prepay-log-modal', {
                target: add ? '$j.F.Admin.Member.PrepayForm' : '$j.F.Admin.Member.PrepayLog',
                data: { mbNo: self.mbNo }, title: add ? '장기선결제 추가' : '장기선결제 내역', width: add ? undefined : '800px',
            });
        });
    }

    async cms(act) {
        const code = String($(`#${this.id} .fw-cms-in`).val() || '').trim();
        if (act !== 'release' && !code) { $j.Ui.Dialog.alert('CMS 코드를 넣어 주세요.'); return; }
        const msg = { register: `CMS 코드 ${code}를 등록할까요?`, edit: `CMS 코드를 ${code}로 바꿀까요?`,
                      release: 'CMS 코드를 해제할까요?\n은행 자동이체 해지는 따로 해야 합니다.' }[act];
        if (this.d.prepay && act === 'register') {
            if (!await $j.Ui.Dialog.confirm(`장기선결제 기간이 남아 있습니다(${this.d.prepay.period}).\nCMS 를 등록하면 CMS 로 받습니다 — 선결제를 환불하지 않으면 회비를 두 번 받게 됩니다.\n그래도 등록할까요?`)) return;
        } else if (!await $j.Ui.Dialog.confirm(msg)) return;
        const url = `/adm/ajax/cms/members/${act}`;
        const data = act === 'register' ? { usernum: this.mbNo, cmscode: code } : (act === 'edit' ? { usernum: this.mbNo, newcmscode: code } : { usernum: this.mbNo });
        const r = await this._post(url, data);
        if (r && r.result) this.load(); else $j.Ui.Dialog.alert((r && (r.reson || r.message)) || '처리하지 못했습니다.');
    }

    _post(url, data) {
        return new Promise((ok) => { $.post(url, data).done((r) => ok(r)).fail(() => ok(null)); });
    }

    // 창 안쪽 모양 — 모달은 body 밑에 붙어 페이지 CSS 에 둘 수 없다. 색은 관리자 토큰
    _style() {
        return `<style>
.fw{font-size:13px}
.fw-head{padding:8px 10px;margin-bottom:8px;border-radius:var(--adm-radius-sm);background:var(--adm-surface-soft)}
.fw-head b{margin-left:6px}
.fw-warn{margin:0 0 8px;font-size:12.5px;color:var(--adm-kw-red, red)}
.fw-row{padding:8px 10px;border:1px solid var(--adm-border);border-radius:var(--adm-radius-sm);margin-bottom:6px}
.fw-row.is-on{border-color:var(--adm-primary, #3b82f6)}
.fw-row__h{display:flex;align-items:center;gap:6px}
.fw-row__help{margin-top:3px;font-size:12px;color:var(--adm-text-muted)}
.fw-row__b{margin-top:6px;display:flex;align-items:center;flex-wrap:wrap;gap:6px}
.fw-now{padding:0 6px;border-radius:var(--adm-radius-xs);background:var(--adm-primary, #3b82f6);color:#fff;font-size:11px}
.fw-sp{flex:1}
.fw-plan{padding:0 6px;border-radius:var(--adm-radius-xs);border:1px solid var(--adm-border);font-size:11px;color:var(--adm-text-muted)}
.fw-ro{font-size:11.5px;color:var(--adm-text-muted)}
.fw-types{margin-top:10px;padding-top:8px;border-top:1px solid var(--adm-border)}
.fw-type{display:inline-block;padding:0 6px;border-radius:var(--adm-radius-xs);background:var(--adm-surface-soft);font-size:12px}
.fw-type.is-fee{color:var(--adm-kw-red, red)}
.fw-empty{padding:20px;text-align:center;color:var(--adm-text-muted)}
</style>`;
    }

    _esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }
}
